/**
 * This file is part of vue-boilerplate.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 TINYMINS.
 */

let enumerateCount = 0;
const exportVar = (enumerate, type): Record<string, string> => {
  const data: Record<string, string> = {};
  type.forEach((action) => {
    enumerateCount += 1;
    data[action] = process.env.NODE_ENV === 'development' ? `${enumerate}.${action}` : `${enumerateCount}`;
  });
  return data;
};

export const COMMON = exportVar('COMMON', [
  'GET_QRCODES', 'GET_SHARES_INVITE_INFO',
  'SAVE_SCROLL', 'REDIRECT',
  'SHOW_LOADING', 'HIDE_LOADING',
  'SHOW_TOAST', 'HIDE_TOAST',
  'SHOW_DIALOG', 'HIDE_DIALOG',
  'SHOW_ACTIONSHEET', 'HIDE_ACTIONSHEET',
  'SHOW_PICKER', 'HIDE_PICKER',
  'UPLOAD_FILE', 'UPLOAD_BLOB', 'UPLOAD_INFO',
  'GET_START',
  'GET_BADGES',
  'ROUTE_BEFORE_CHANGE', 'ROUTE_CHANGE', 'ROUTE_HISTORY_MODE',
  'SET_BODY_SCROLLABLE', 'REMOVE_BODY_SCROLLABLE',
  'SET_BODY_AUTO_HEIGHT', 'REMOVE_BODY_AUTO_HEIGHT',
  'SET_BODY_BACKGROUND', 'REMOVE_BODY_BACKGROUND',
  'SET_PAGE_TITLE', 'SET_VIEWPORT_SIZE',
  'SET_HEADER_HEIGHT', 'SET_HEADER_EXTRA_HEIGHT', 'REMOVE_HEADER_EXTRA_HEIGHT',
  'SET_TABBAR_HEIGHT', 'SET_FOOTER_EXTRA_HEIGHT', 'REMOVE_FOOTER_EXTRA_HEIGHT',
  'SET_NAVBAR_VISIBLE', 'REMOVE_NAVBAR_VISIBLE',
  'SET_TABBAR_VISIBLE', 'REMOVE_TABBAR_VISIBLE',
  'GET_WECHAT_SDK_INFO', 'SET_PAGE_SHARE',
  'CONNECT', 'AUDIO_SET_PROPS',
  'GET_BANK_INFO', 'GET_SUBMIT_EXCEPTION',
  'SET_IMAGE_PICKER_INTERFACE', 'SHOW_IMAGE_PICKER', 'HIDE_IMAGE_PICKER',
]);

export const USER = exportVar('USER', [
  'GET', 'UPDATE',
  'GET_PHONE_CODE', 'LOGIN', 'LOGOUT',
  'GET_PROFILE_OPTIONS',
  'GET_GAMES',
  'GET_GAME_OPTIONS', 'GET_GAME_OPTIONS_SUCCESS',
  'SET_PROFILE', 'SET_GAME',
  'SET_PHONE', 'GET_AT_LIST', 'CHECK_REAL_NAME',
  'GET_ONLINE_USER',

  'GET_BLOCKERS', 'SET_BLOCKER', 'DEL_BLOCKER', 'GET_BLOCKER', 'ADD_BLOCKER',
  'GET_KEYWORDS', 'ADD_KEYWORD', 'DEL_KEYWORD',
  'GET_FOLLOWERS', 'DEL_FOLLOWER', 'ADD_FOLLOWER',
  'GET_ACCESS', 'GET_VIP',
  'GET_OTHER', 'CHANGE_ISFOLLOWED', 'SET_PRISONER',

  'GET_ADMINS', 'GET_ADMIN', 'SET_ADMIN', 'DEL_ADMIN', 'GET_ID', 'GET_NAME',

  'FIND', 'GET_CP', 'SET_CP', 'DEL_CP',
  'MATCHES_REQUEST', 'MATCHES_SET_INDEX',

  'GET_VERIFIED_INFO', 'POST_VERIFIED_INFO', 'PUT_VERIFIED_INFO',
  'GET_VERIFIED_INFO_LIST', 'REFRESH_VERIFIED_INFO_LIST',

  'GET_IM_SIG', 'GET_IM_USER_INFO',

  'GET_COIN_TRANSFER_INFO', 'POST_COIN_TRANSFER',
  'GET_COIN_LOG', 'GET_POINT_LOGS',
  'EXCHANGE_CODE', 'GET_CODE', 'USE_CODE',
  'GET_CODE_SALES', 'GET_CODE_LIST',
  'SET_ORDER', 'GET_ORDER', 'GET_ORDERS',
  'CREATE_CODE', 'GET_CODES',
  'GET_CODE_FEATURES', 'GET_CODE_STOCKS', 'SET_CODE_STOCK',

  'GET_MEDALS', 'EQUIP_MEDAL',
  'GET_FIELD_INFOS', 'EXCHANGE_USE_CODE',
  'GET_ACCOUNTS', 'GET_WX_TRANSFER_AUTH', 'CREATE_ACCOUNT', 'SET_ACCOUNT',

  'GET_WEBRTC_OPTIONS', 'CREATE_WEBRTC_TOKEN',
]);

export const SECRET = exportVar('SECRET', [
  'SEEK_CACHE',

  'GET_FILTER_INFO',
  'GET_NAV', 'NAV_BADGE_UPDATE',
  'GET_TOPIC_LIST', 'GET_TOPIC', 'SET_TOPIC',

  'GET_POST_LIST', 'GET_POST_LIST_SUCCESS', 'GET_POST_LIST_FAILURE',

  'POST_NEW_REQUEST',
  'POST_GET', 'POST_DEL', 'POST_UPDATE',
  'POST_CHANGE_RELATIONS', 'POST_DEL_RELATIONS',

  'SAVE_SCROLL', 'SET_LIST_INFO', 'SET_POST_INFO',
  'GET_MENU', 'GET_TAGS',
  'SEARCH_REQUEST', 'SEARCH_SUCCESS', 'SEARCH_FAILURE',
  'SEARCH_TIP_REQUEST', 'SEARCH_TIP_SUCCESS',

  'GET_EMOTIONS', 'GET_EMOTIONS_SUCCESS', 'GET_EMOTIONS_FAILURE',
  'GET_LUCKY', 'GET_INPUT_TIPS',

  'POST_COMMENT_POST',
  'GET_COMMENT', 'GET_COMMENT_POST',
  'COMMENT_DEL_REQUEST', 'COMMENT_DEL_SUCCESS', 'COMMENT_DEL_FAILURE',
  'COMMENT_CHANGE_RELATIONS', 'COMMENT_DELETE_RELATIONS',
  'COMMENT_SAVE_SCROLL',
  'COMMENT_UPDATE',

  'GET_ROOM_LIST_ALL', 'GET_ROOM', 'SET_ROOM', 'SUBSCRIBE_ROOM',

  'GET_GROUP_FILTERS',

  'GET_TOPS_META', 'GET_TOPS_TABS', 'GET_TOPS',

  'GET_STICKY_RULES',
]);

export const MSG = exportVar('MSG', [
  'LIST_REQUEST', 'LIST_SUCCESS', 'LIST_FAILURE',
  'SAVE_SCROLL', 'DELETE', 'DELETE_SUCCESS',
]);

export const GAME = exportVar('GAME', [
  'GET_GAMES', 'GET_DAILY',
]);

export const JX3 = exportVar('JX3', [
  'SEARCH_REQUEST_AUTOCOMPLETE', 'SEARCH_REQUEST_AUTOCOMPLETE_SUCCESS',
  'SEARCH_REQUEST', 'SEARCH_REQUEST_SUCCESS',
]);

export const QUIZ = exportVar('QUIZ', [
  'GET_TOPICS', 'GET_TOPS', 'GET_INVITATIONS',
  'GET_PROFILE', 'PUT_PROFILE',
  'POST_RECORDS', 'PUT_RECORDS',
]);

export const PLAY = exportVar('PLAY', [
  'CREATE_SERVICE', 'MODIFY_SERVICE', 'GET_SERVICE',
  'GET_START', 'GET_LIST', 'GET_SERVICES',
  'GET_SERVICE_LIST',
  'CREATE_ORDER', 'PUT_ORDER', 'GET_ORDER', 'UPDATE_ORDER',
  'GET_ORDER_LIST',
  'POST_APPRAISE', 'PUT_APPRAISE', 'GET_APPRAISE_LIST',
  'POST_COMPLAINT',
]);

export const CHAT = exportVar('CHAT', [
  'USER_LOGIN', 'USER_LOGOUT',
  'GET_CONVERSATION_LIST', 'DELETE_CONVERSATION',
  'SET_MESSAGE_READ',
  'GET_HISTORY', 'SEEK_CACHE',
  'SEND_PICTURE', 'SEND_TEXT',
  'GET_BLACK_LIST', 'ADD_BLACK_LIST', 'DELETE_BLACK_LIST',
]);

export const LOGGER = exportVar('LOGGER', [
  'GET_LOGGER_LIST',
]);

export const TONES = exportVar('TONES', [
  'GET_TONES_START', 'GET_TONES_ACQUIRE', 'GET_TONES_MATERIAL', 'POST_USER_TONES', 'GET_USER_TONES',
  'GET_USER_TONES_DETAIL', 'PUT_USER_TONES_DETAIL',
]);

export const MESSAGE = exportVar('MESSAGE', [
  'GET_CONTACT_LIST', 'GET_MESSAGE_LIST', 'GET_MESSAGE_LIST_NEW', 'POST_MESSAGE', 'DEL_MESSAGE',
]);
